import type { EpiClarifyingQuestion, EpiMessage } from '../types/epi-chat-types';

/**
 * The clarifying question to pin above the composer
 * (``research_assistant_pinned_clarify``): the unanswered question on the
 * transcript's LAST assistant message. An unanswered question on an older
 * message has been superseded (the researcher typed past it or the agent
 * moved on) and lives in the stream only — pinning it would offer answers
 * the agent is no longer waiting for.
 */
export const getPendingClarifyingQuestion = (
  messages: ReadonlyArray<EpiMessage>
): EpiClarifyingQuestion | null => {
  const last = messages[messages.length - 1];
  if (!last || last.role === 'user') return null;
  for (let index = last.parts.length - 1; index >= 0; index -= 1) {
    const part = last.parts[index];
    if (part.kind === 'clarifying_question' && !part.question.answered) {
      return part.question;
    }
  }
  return null;
};
